import { useEffect, useState } from "react";
import { PageHeader, SectionCard, StatCard } from "@/components/ui-bits";
import { TrendingUp, Users, ClipboardList } from "lucide-react";
import api from "@/lib/api";
import { BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer } from "recharts";

export default function Analytics() {
  const [perf, setPerf] = useState([]);
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/stats/assessment-performance").then(r => setPerf(r.data));
    api.get("/stats/overview").then(r => setStats(r.data));
  }, []);

  return (
    <div>
      <PageHeader title="Analytics" subtitle="Aggregate performance across all your assessments." />
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
        <StatCard label="Assessments" value={stats?.assessments ?? "—"} icon={ClipboardList} accent="blue" />
        <StatCard label="Total attempts" value={stats?.results ?? "—"} icon={Users} accent="purple" />
        <StatCard label="Pass rate" value={`${stats?.pass_rate ?? 0}%`} icon={TrendingUp} accent="green" />
      </div>

      <SectionCard title="Pass vs Fail per assessment">
        {perf.length === 0 ? (
          <div className="text-sm text-slate-500 py-10 text-center">No data yet.</div>
        ) : (
          <div className="h-80">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={perf}>
                <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" vertical={false} />
                <XAxis dataKey="title" stroke="#64748B" fontSize={12} />
                <YAxis stroke="#64748B" fontSize={12} />
                <Tooltip contentStyle={{ background: "#fff", border: "1px solid #E2E8F0", borderRadius: 0 }} />
                <Bar dataKey="passed" name="Passed" fill="#22C55E" />
                <Bar dataKey="failed" name="Failed" fill="#EF4444" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        )}
      </SectionCard>
    </div>
  );
}
